<template><div class="main-wrapper">
  <layout-header></layout-header>
  <layout-navbar></layout-navbar>
  <!-- Page Wrapper -->
  <div class="page-wrapper">

    <!-- Page Content -->
    <div class="content container-fluid">
      <div class="crms-title row bg-white">
        <div class="col">
          <h3 class="page-title m-0">
                        <span class="page-title-icon bg-gradient-primary text-white mr-2">
                          <i class="feather-database"></i>
                        </span> {{customer_name}} </h3>
        </div>
        <div class="col text-right">
          <ul class="breadcrumb bg-white float-right m-0 pl-0 pr-0">
            <li class="breadcrumb-item"><router-link to="/index">GAP Bearbeiten</router-link></li>
            <li class="breadcrumb-item active">{{customer_name}}</li>
          </ul>
        </div>
      </div>
        <div id="surveyCreatorContainer"></div>
    </div>
  </div>
</div>
</template>

<script>
  import * as SurveyCreator from "survey-creator-knockout";


  import * as Survey from "survey-core";
  import * as widgets from "surveyjs-widgets";
  import { init as customWidget } from "@/components/survey/customwidget";

  import "survey-core/defaultV2.css";
  import "survey-creator-core/survey-creator-core.css";
  import service from '@/utils/request';


  // widgets.icheck(Survey);
  widgets.select2(Survey);
  widgets.inputmask(Survey);
  widgets.jquerybarrating(Survey);
  widgets.jqueryuidatepicker(Survey);
  widgets.nouislider(Survey);
  widgets.select2tagbox(Survey);
  widgets.sortablejs(Survey);
  widgets.ckeditor(Survey);
  widgets.autocomplete(Survey);
  widgets.bootstrapslider(Survey);
  customWidget(Survey);

export default {
  name: 'TomsEdit',
  data() {
    return {
      surveyJSON: ''
    }
  },
  created() {
    this.getSurveyBody()
  },
  methods: {
    modifySurvey: function(e) {
      service.request({
        url: 'survey/v1/survey/update/3/',
        method: 'PUT',
        data: { 'body': e }
      }).then(function(response) {
        console.log('success')
      })
    },
    getSurveyBody: async function() {
      const that = this
      service.request({
        url: 'survey/v1/survey/3/',
        method: 'GET',
        responseType: 'json'
      }).then(function(response) {
        console.log('success')
        that.surveyJSON = JSON.stringify(response.data.body)
        // const model = new SurveyVue.Model(that.surveyJSON)
        // model.onCompleting.add(
        //   function(sender, options) {
        //     if (!that.surveyConfirmed) {
        //       options.allowComplete = that.completeOption
        //       that.resultBody = JSON.stringify(sender.data)
        //       that.organizeResult(JSON.stringify(sender.data))
        //       that.dialogVisible = true
        //     }
        //   }
        // )
        const options = { showLogicTab: true, haveCommercialLicense: true }
        that.surveyCreator = new SurveyCreator.SurveyCreator(options)
        that.surveyCreator.saveSurveyFunc = function() {
          that.modifySurvey(JSON.parse(that.surveyCreator.text))
        }
        that.surveyCreator.text = that.surveyJSON;
        that.surveyCreator.render("surveyCreatorContainer");
      }).catch(function(err) {
        console.log(err)
      })
    }
  }
}
</script>

<style>
@import '../../assets/bootstrap/css/bootstrap.min.css';
#surveyCreatorContainer {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
